import React from "react";
import { FinancialRiskModal } from "./FinancialRiskModal";

interface ModalContext {
  displayFinancialRiskModal: (companyId: number) => void;
}

const ModalContext = React.createContext<ModalContext | null>(null);

export const useModals = () => {
  return React.useContext(ModalContext);
}

export const ModalsProvider = (props: React.PropsWithChildren<unknown>) => {
  const [financialRiskCompanyId, setFinancialRiskCompanyId] = React.useState<number>(null);

  const context = React.useMemo<ModalContext>(() => ({
    displayFinancialRiskModal: setFinancialRiskCompanyId
  }), []);

  return <ModalContext.Provider value={context}>
    {props.children}

    {financialRiskCompanyId != null && <FinancialRiskModal
      key={financialRiskCompanyId}
      companyId={financialRiskCompanyId}
      onClose={() => setFinancialRiskCompanyId(null)}
    />}
  </ModalContext.Provider>;
}
